module.exports = __webpack_public_path__ + "img/icon04.559fdf9f.png";